
import React, { useEffect, useState, useRef } from "react"
import { Box, Text } from "@chakra-ui/core"
import { localPoint } from "@vx/event"
import dayjs from "dayjs"

import { useTooltip } from "../../store"
import colors from "../Layout/colors"

const LatestNumber = ({ latestNumber, x, y }) => {
  const showTooltip = useTooltip(state => state.showTooltip)
  return !showTooltip ? (
    <g style={{ pointerEvents: "none" }}>
      <Box
        as="circle"
        color="gray.50"
        fill="currentcolor"
        r={4}
        cx={x(new Date(latestNumber.date))}
        cy={y(latestNumber.ncumul_conf)}
      />
      <Text
        as="text"
        textAnchor="middle"
        x={x(new Date(latestNumber.date))}
        y={y(latestNumber.ncumul_conf) - 6}
        fontSize={["0.5rem", null, "0.5rem", "0.75rem"]}
        fontWeight={600}
        color="gray.50"
        stroke="currentcolor"
        strokeWidth={3}
        fill="currentcolor"
      >
        { latestNumber.ncumul_conf }
      </Text>
      <Text
        as="text"
        textAnchor="middle"
        x={x(new Date(latestNumber.date))}
        y={y(latestNumber.ncumul_conf) - 6}
        fontSize={["0.5rem", null, "0.375rem", "0.75rem"]}
        fontWeight={600}
        color="yellow.700"
        fill="currentcolor"
        fontFamily="mono"
      >
        { latestNumber.ncumul_conf }
      </Text>
      <Text
        as="text"
        textAnchor="middle"
        x={x(new Date(latestNumber.date))}
        y={y(latestNumber.ncumul_conf) - 18}
        fontSize="0.5rem"
        fontWeight={700}
        color="gray.50"
        stroke="currentcolor"
        strokeWidth={3}
        fill="currentcolor"
      >
        { dayjs(latestNumber.date).format("DD.MM") }
      </Text>
      <Text
        as="text"
        textAnchor="middle"
        x={x(new Date(latestNumber.date))}
        y={y(latestNumber.ncumul_conf) - 18}
        fontSize={["0.375rem", null, "0.3125rem", "0.5rem"]}
        fontWeight={700}
        color="gray.700"
        fill="currentcolor"
        fontFamily="mono"
      >
        { dayjs(latestNumber.date).format("DD.MM") }
      </Text>
      <Box
        as="circle"
        color="yellow.600"
        fill="currentcolor"
        r={3}
        cx={x(new Date(latestNumber.date))}
        cy={y(latestNumber.ncumul_conf)}
      />
    </g>
  ) : null
}

const Tooltip = ({ x, y, factor, confirmedCases }) => {
  const xCoordinate = useTooltip(state => state.x)
  const showTooltip = useTooltip(state => state.showTooltip)
  const date = dayjs(x.invert(xCoordinate / factor))
  const xDate = x(new Date(date.format("YYYY-MM-DD")))
  const data = confirmedCases.find(s => s.date === date.format("YYYY-MM-DD"))
  return showTooltip ? (
    <>
      <Box
        as="line"
        x1={xDate}
        x2={xDate}
        y1={36}
        y2={120}
        stroke="currentcolor"
        strokeWidth={3}
        color="gray.50"
        style={{ pointerEvents: "none" }}
      />
      <Box
        as="line"
        x1={xDate}
        x2={xDate}
        y1={36}
        y2={120}
        stroke="currentcolor"
        color="gray.300"
        style={{ pointerEvents: "none" }}
      />
      {
        data && data.ncumul_conf !== "MISSING" ? (
          <g style={{ pointerEvents: "none" }}>
            <Text as="text" x={xDate} y={y(data.ncumul_conf) - 18} textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize={["0.5rem", null, "0.375rem", "0.75rem"]} stroke={colors.gray[50]} strokeWidth={4} fill={colors.gray[50]}>
              { date.format("DD.MM") }
            </Text>
            <Text as="text" x={xDate} y={y(data.ncumul_conf) - 18} color="gray.700" fill="currentcolor" textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize={["0.375rem", null, "0.3125rem", "0.5rem"]}>
              { date.format("DD.MM") }
            </Text>

            <Text as="text" x={xDate} y={y(data.ncumul_conf) - 6} textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize={["0.375rem", null, "0.3125rem", "0.5rem"]} stroke={colors.gray[50]} strokeWidth={4} fill={colors.gray[50]}>
              { data ? (data.ncumul_conf === "MISSING") ? "N/A" : data.ncumul_conf : "" }
            </Text>
            <Text as="text" x={xDate} y={y(data.ncumul_conf) - 6} color="yellow.700" fill="currentcolor" textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize={["0.375rem", null, "0.3125rem", "0.5rem"]}>
              { data ? (data.ncumul_conf === "MISSING") ? "N/A" : data.ncumul_conf : "" }
            </Text>
            <circle
              cx={xDate}
              cy={y(data.ncumul_conf)}
              r={4}
              fill={colors.gray[50]}
            />
            <circle
              cx={xDate}
              cy={y(data.ncumul_conf)}
              r={3}
              fill={colors.yellow[600]}
            />
          </g>
        ) : (
          <g style={{ pointerEvents: "none" }}>
            <Text as="text" x={xDate} y={74} textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize="0.5rem" stroke={colors.gray[50]} strokeWidth={4} fill={colors.gray[50]}>
              { date.format("DD.MM") }
            </Text>
            <Text as="text" x={xDate} y={74} color="gray.500" fill="currentcolor" textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize="0.5rem">
              { date.format("DD.MM") }
            </Text>
            <Text as="text" x={xDate} y={82} textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize="0.5rem" stroke={colors.gray[50]} strokeWidth={4} fill={colors.gray[50]}>
              { data ? (data.ncumul_conf === "MISSING") ? "N/A" : "" : "N/A" }
            </Text>
            <Text as="text" x={xDate} y={82} color="gray.500" fill="currentcolor" textAnchor="middle" fontFamily="mono" fontWeight={700} fontSize="0.5rem">
              { data ? (data.ncumul_conf === "MISSING") ? "N/A" : "" : "N/A" }
            </Text>
          </g>
        )
      }
    </>
  ) : null
}

const LineChart = ({ scaleMetaData, confirmedCases, lineGenerator, confirmedCases2, lineGenerator2, x, y }) => {
  const show = useTooltip(state => state.show)
  const hide = useTooltip(state => state.hide)

  const chartGroup = useRef()
  const [factor, setFactor] = useState(1)

  const handleMove = (evt) => {
    const p = localPoint(evt)
    const today = new Date().getTime()
    const date = dayjs(x.invert(p.x / factor)).toDate().getTime()
    const first = new Date("2020-02-25").getTime()
    if (date - today > 0 || first - date > 0) return
    show({ x: p.x, y: p.y })
  }

  const handleLeave = () => {
    hide()
  }

  useEffect(() => {
    const handleResize = () => {
      const g = chartGroup.current
      const CTM = g.getCTM() || {}
      setFactor(CTM.a || 1)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return function() {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const latestNumber = confirmedCases2[confirmedCases2.length - 1]

  return (
    <Box
      as="svg"
      viewBox="0 0 120 120"
      color="yellow.600"
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      <g style={{ pointerEvents: "none" }} ref={chartGroup}>
        {
          scaleMetaData.ticks.map(tick => {
            return (
              <g key={`tick-${tick}`} transform={`translate(0 ${y(tick)})`}>
                <Text fontFamily="mono" as="text" color="gray.600" fill="currentcolor" x="4" y="-4" fontSize="0.5rem" fontWeight={600}>{ tick }</Text>
                <Box strokeDasharray={[2,1.5]} strokeLinecap="round" as="line" color="gray.400" stroke="currentcolor" strokeWidth={0.5} x1={0} x2={120} />
              </g>
            )
          })
        }
      </g>

      <g style={{ pointerEvents: "none" }}>
        <path d={lineGenerator2(confirmedCases2)} strokeLinejoin="bevel" strokeLinecap="round" fill="none" stroke={colors.gray[50]} strokeWidth={4} />
        <path d={lineGenerator2(confirmedCases2)} strokeLinejoin="bevel" strokeLinecap="round" fill="none" stroke={colors.yellow[200]} strokeWidth={1} />
        <path d={lineGenerator(confirmedCases)} strokeLinejoin="bevel" strokeLinecap="round" fill="none" stroke={colors.yellow[600]} strokeWidth={2} />
      </g>

      <LatestNumber latestNumber={latestNumber} x={x} y={y} />
      <Tooltip x={x} y={y} factor={factor} confirmedCases={confirmedCases} />
    </Box>
  )
}

export default LineChart
